import React from "react";
import PropTypes from "prop-types";
import styleObjectToProps from "core-web/utils/styleObjectToProps";
import styled from "theme/libs/styled";
import Wysiwyg from "theme/libs/wordpress/components/Wysiwyg";

const StyledBox = styled("div")``;

const Box = ({ text, textStyles, ...restProps }) => {
    const textStyle = styleObjectToProps(textStyles);
    return (
        <StyledBox {...restProps} {...textStyle}>
            <Wysiwyg data={text} />
        </StyledBox>
    );
};

Box.propTypes = {
    children: PropTypes.node,
    text: PropTypes.string.isRequired,
    textStyle: PropTypes.string,
    to: PropTypes.string,
};

Box.defaultProps = {
    children: [],
    textStyle: "Buenos Aires/14-120 Regular",
    to: null,
};

export default Box;
